const _ = require('./enum');

const regions = {
  [_.AFRICA]: { id: _.AFRICA, label: 'Africa', code: 2 },
  [_.AMERICAS]: { id: _.AMERICAS, label: 'Americas', code: 19 },
  [_.ANTARCTICA]: { id: _.ANTARCTICA, label: 'Antarctica', code: 10 },
  [_.ASIA]: { id: _.ASIA, label: 'Asia', code: 142 },
  [_.EUROPE]: { id: _.EUROPE, label: 'Europe', code: 150 },
  [_.OCEANIA]: { id: _.OCEANIA, label: 'Oceania', code: 9 },
};

module.exports = regions;
